import React, { useEffect } from "react";
import "../styles/StaticPages.css";

export default function ShippingPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="sp-root">
      <div className="sp-container">
        <div className="sp-header">
          <div className="sp-chip">Legal</div>
          <h1 className="sp-title">Shipping & Returns Policy</h1>
          <p className="sp-sub">
            Last Updated: February 24, 2026 <br />
            This policy outlines our shipping, return, and refund procedures.
          </p>
        </div>

        <div className="sp-card">

          <div className="sp-section">
            <h2 className="sp-section-title">1. Shipping</h2>
            <p className="sp-section-text">
              Easyworld Online ships products worldwide from Nepal using trusted
              third-party courier services. Delivery times are estimates and may
              vary depending on destination, logistics, and external factors.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">2. Customs & Duties</h2>
            <p className="sp-section-text">
              Customers are responsible for any applicable customs duties, taxes,
              or import charges unless otherwise stated at the time of purchase.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">3. Returns</h2>
            <p className="sp-section-text">
              If you receive a defective or incorrect product, you must contact us
              within 48 hours of delivery. Return requests must be submitted in
              writing via email at <strong>support@easyworldonline.com</strong>.
            </p>
            <p className="sp-section-text">
              Once your request is reviewed, the issue will be resolved or appropriate
              action will be taken within 8–10 working days.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">4. Refunds</h2>
            <p className="sp-section-text">
              Approved refunds will be processed using the original payment method
              within a reasonable timeframe.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">5. Non-Returnable Items</h2>
            <p className="sp-section-text">
              Custom-made or personalized items are not eligible for return or refund
              unless they are defective or incorrect.
            </p>
          </div>

          <div className="sp-section">
            <h2 className="sp-section-title">6. Contact</h2>
            <p className="sp-section-text">
              For any questions regarding shipping, returns, or refunds, please
              contact us through our website or email support.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}